import {
  Button,
  Col,
  Drawer,
  Flex,
  Form,
  Input,
  message,
  Modal,
  Radio,
  Row,
  Select,
  Space,
} from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import IntlMessage from '../../components/IntlMessage';
import { orderStatus } from './order_status.type';
import { paymentStatus } from './payment.type';
import { useIntl } from 'react-intl';
import busOrdersApi from '../../api/bus_orders';
import CountryData from '../../utils/countrydata';

const { Option } = Select;

const BookingStatusForm = (props) => {
  const {
    isModalBookingStatus,
    setIsModalBookingStatus,
    onCloseModalBookingStatus,
    currentData,
    onRefresh,
  } = props;
  const [form] = Form.useForm();
  const intl = useIntl();
  let initialValues = {
    ...currentData,
    pay_status: currentData?.pay_status ?? null,
    order_status: currentData?.order_status ?? '',
  };

  const [payMethod, setPaymentMethod] = useState('');
  const [isLoadingSave, setIsLoadingSave] = useState(false);
  const onChangePaymentMethod = (e) => {
    console.log('radio checked', e.target.value);
    setPaymentMethod(e.target.value);
  };

  const handleOk = async () => {
    form
      .validateFields()
      .then(async (values) => {
        Promise.all([
          busOrdersApi.updatePaymentStatus(currentData?.id, {
            pay_status: values.pay_status,
          }),
          busOrdersApi.updateOrderStatus(currentData?.id, {
            order_status: values.order_status,
          }),
        ])
          .then((res) => {
            message.success('Updated successfully');
            setIsModalBookingStatus(false);
            onRefresh();
          })
          .catch((error) => {
            // setIsModalBookingStatus(false);
            throw new Error('Update failed');
          });
      })
      .catch((info) => {
        console.log('Validate Failed:', info);
      });
  };

  const onChangePayStatus = (e) => {};

  const onChangeOrderStatus = (e) => {};

  useEffect(() => {
    form.resetFields();
  }, [form]);

  const [payMethods, setPaymentMethods] = useState(null);

  useEffect(() => {
    const fetch = async () => {
      busOrdersApi
        .getPaymentMethodOperator(currentData?.route?.operator?.id)
        .then((res) => {
          console.log('payMethods1', res);
          setPaymentMethods(res);
        })
        .catch((err) => console.log(err));
    };
    currentData?.route?.operator?.id && fetch();
  }, [currentData]);

  const handleSendSMS = async () => {
    setIsLoadingSave(true);
    try {
      if (payMethod === 'wave' && currentData?.route?.operator?.id) {
        const data = {
          booking_id: currentData.id,
          company_id: currentData?.route?.operator?.id,
          phone: '+221' + form.getFieldValue('mobile'),
        };
        const res_pay = await busOrdersApi.paymentWave(data);
        console.log('res_pay', res_pay);
        if (res_pay) {
          message.success('Create booking and send SMS successfully!');
          setIsLoadingSave(false);
          setIsModalBookingStatus(false);
          onRefresh();
        } else {
          message.error('send SMS fail!');
          setIsLoadingSave(false);
          setIsModalBookingStatus(false);
          onRefresh();
        }
      } else if (
        payMethod === 'orangemoney' &&
        currentData?.route?.operator?.id
      ) {
        const data = {
          booking_id: currentData.id,
          company_id: currentData?.route?.operator?.id,
          phone: '+221' + form.getFieldValue('mobile'),
        };
        const res_pay = await busOrdersApi.paymentOm(data);
        if (res_pay) {
          message.success('Create booking and send SMS successfully!');
          setIsLoadingSave(false);
          setIsModalBookingStatus(false);
          onRefresh();
          form.resetFields();
        } else {
          message.error('send SMS fail!');
          setIsLoadingSave(false);
          setIsModalBookingStatus(false);
          onRefresh();
        }
      } else {
        message.success('Create booking successfully!');
        setIsLoadingSave(false);
        setIsModalBookingStatus(false);
        onRefresh();
      }
    } catch (error) {
      message.error('send SMS fail!');
      setIsLoadingSave(false);
      setIsModalBookingStatus(false);
      onRefresh();
    }
  };
  return (
    <Modal
      title={<IntlMessage id="global.payment_methods" />}
      open={isModalBookingStatus}
      destroyOnClose={true}
      onCancel={onCloseModalBookingStatus}
      width="40%"
      onOk={onCloseModalBookingStatus}
      footer={[
        <Button
          key="submit"
          type="primary"
          htmlType="submit"
          loading={isLoadingSave}
          onClick={handleSendSMS}>
          {<IntlMessage id="global.save" />}
        </Button>,
      ]}>
      <Form
        labelCol={{
          span: 0,
        }}
        wrapperCol={{
          span: 24,
        }}
        initialValues={initialValues}
        labelAlign="left"
        form={form}
        name="control-hooks"
        style={{ maxWidth: 1000 }}>
        <>
          <Flex
            style={{ marginTop: 16, width: '100%' }}
            vertical
            align="start"
            gap={5}>
            <Radio.Group
              style={{ width: '100%' }}
              onChange={onChangePaymentMethod}
              value={payMethod}>
              <Space
                direction="vertical"
                align="start"
                style={{ width: '100%' }}>
                {payMethods &&
                  payMethods.length > 0 &&
                  payMethods.map((item) => {
                    return (
                      <>
                        <Radio value={item.method}>{item?.display}</Radio>
                        {payMethod === item.method && (
                          <Row gutter={[16, 16]}>
                            <Col span={8}>
                              <Form.Item
                                name={'phone_code'}
                                initialValue={'+221'}>
                                <Select
                                  style={{ width: '100%' }}
                                  placeholder="Select phone code"
                                  showSearch
                                  defaultValue={`+221`}
                                  options={CountryData.map((country, i) => {
                                    return {
                                      label: `(+${country.code}) ${country.country}`,
                                      value: `+${country.code}`,
                                    };
                                  })}
                                />
                              </Form.Item>
                            </Col>
                            <Col span={16}>
                              <Form.Item
                                name={'mobile'}
                                rules={[
                                  {
                                    required: true,
                                    message: (
                                      <IntlMessage id="global.requiredfield" />
                                    ),
                                  },
                                  {
                                    message: (
                                      <IntlMessage id={`global.numberfield`} />
                                    ),
                                    pattern: new RegExp(/^[0-9]+$/),
                                  },
                                ]}>
                                <Input style={{ width: '100%' }} />
                              </Form.Item>
                            </Col>
                          </Row>
                        )}
                      </>
                    );
                  })}

                <Radio value={'pay_later'}>Pay later</Radio>
              </Space>
            </Radio.Group>
          </Flex>
        </>
      </Form>
    </Modal>
  );
};

export default BookingStatusForm;
